import { useEffect, useRef, useState } from "react";
import { useAuth } from "@/hooks/useAuth";
import { supabase } from "@/integrations/supabase/client";

export function useIsAdmin() {
  const { user, loading: authLoading } = useAuth();
  const userId = user?.id ?? null;
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);
  const resolvedUserIdRef = useRef<string | null>(null);

  useEffect(() => {
    let active = true;
    if (authLoading) return;
    if (!userId) {
      resolvedUserIdRef.current = null;
      setIsAdmin(false);
      setLoading(false);
      return;
    }
    if (resolvedUserIdRef.current !== userId) {
      setIsAdmin(false);
    }
    setLoading(true);
    supabase
      .from("user_roles")
      .select("role")
      .eq("user_id", userId)
      .eq("role", "admin")
      .maybeSingle()
      .then(({ data }) => {
        if (!active) return;
        resolvedUserIdRef.current = userId;
        setIsAdmin(!!data);
        setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [userId, authLoading]);

  return { isAdmin, loading: loading || authLoading };
}